import { createContext, useContext } from 'react';

import { useControls } from './useControls';

export interface IUseSelectReturn extends ReturnType<typeof useControls> {}

const SelectContext = createContext<IUseSelectReturn>(null);

const useSelectContext = () => {
  return useContext(SelectContext);
};

export { SelectContext, useSelectContext };
